import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  type DocumentUploadRequest,
  postProjectsProjectIDDocuments,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import {
  getResourcePath,
  Resources,
} from "Infrastructure/Translations/Resources";
import { PROJECTS_QUERY_KEYS } from "Projects/Api/Queries/queryKeys";

export function useUploadProjectDocumentMutation(projectID: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse(
      ({ file, displayName }: DocumentUploadRequest) =>
        postProjectsProjectIDDocuments({ file, displayName }, projectID),
      {
        translationPrefix: getResourcePath(Resources.ApiErrors.DocumentUpload),
      },
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: PROJECTS_QUERY_KEYS.documents(projectID),
      });
    },
  });
}
